import { load } from "recaptcha-v3";

export namespace Misc {
    let recaptcha;

    export function guid(): string {
        return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g,
            c => {
                const r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
    }

    export async function initRecaptcha(key) {
        recaptcha = await load(key, { autoHideBadge: true });
    }

    export async function getRecaptchaToken(action): Promise<string> {
        const token = await recaptcha.execute(action);
        return token;
    }

    export function alertIe() {
        const ua = window.navigator.userAgent;
        const ie = ua.indexOf("MSIE") > 0 || ua.indexOf("Trident") > 0;
        if (ie) {
            alert("Internet Explorer is not supported. Please use Chrome, Firefox or Edge.");
        }
        return ie;
    }
}
